import { Component, inject, Injectable, input } from '@angular/core';
import {
  CustomColumnComponent,
  DataService,
  SharedModule,
} from '@vendure/admin-ui/core';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
class ChannelCurrencyService {
  currencyCode$ = inject(DataService)
    .settings.getActiveChannel()
    .mapStream(({ activeChannel }) => activeChannel.defaultCurrencyCode)
    .pipe(shareReplay(1));
}

@Component({
  selector: 'ft-credit-limit-column',
  imports: [SharedModule],
  template: `
    @if (rowItem().customFields.creditLimit != null) {
      {{
        rowItem().customFields.creditLimit
          | localeCurrency: (currencyCode$ | async)
      }}
    } @else {
      -
    }
  `,
  standalone: true,
})
export class CreditLimitColumnComponent implements CustomColumnComponent {
  rowItem = input.required<{ customFields: { creditLimit: number | null } }>();
  currencyCode$ = inject(ChannelCurrencyService).currencyCode$;
}

@Component({
  selector: 'ft-credit-balance-column',
  imports: [SharedModule],
  template: `
    @if (rowItem().customFields.creditBalance != null) {
      {{
        rowItem().customFields.creditBalance
          | localeCurrency: (currencyCode$ | async)
      }}
    } @else {
      -
    }
  `,
  standalone: true,
})
export class CreditBalanceColumnComponent implements CustomColumnComponent {
  rowItem = input.required<{
    customFields: { creditBalance: number | null };
  }>();
  currencyCode$ = inject(ChannelCurrencyService).currencyCode$;
}
